import { initWhenReady, createStaticSlider } from "../../../../../../themes/custom/ev_theme/frontend/js/components/sliders";
import { fields, renderFilters } from "../filters/filters";
import { setSlider, bindRangeInputs, setRangeHint } from "../filters/sliderRange";
import { loadSliderHiglighted, loadWithoutResults } from "../script";
import { loadInfoData, loadFilterOrder } from "../results-load/results-ui";
import { prepareInitialFilters } from "./results-prefilters";
export async function loadData(isBuilder) {
    var _a, _b, _c;
    isBuilder ? window.rangeValueBuilder = 12 : window.rangeValue = 12;
    const data = JSON.parse(((_b = (_a = document.getElementById('app')) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.projects) || '{}');
    if (!isBuilder && document.getElementById('js-project-banner')) {
        (_c = document.getElementById("datos1")) === null || _c === void 0 ? void 0 : _c.classList.remove('d-none');
    }
    prepareInitialFilters(data);
}
export async function loadApis(filter) {
    if (document.getElementById("featuredProjectsVue")) {
        document.getElementById("featuredProjectsVue").classList.add('d-none');
    }
    const res = await fetch(`/results-api${filter}`);
    const finalValues = await res.json();
    window.app.datos1 = finalValues.Items;
    window.app.featuredProjects = finalValues.outputFeatured;
    document.getElementById('number-total').innerHTML = finalValues.NumItems;
    loadSeoTags(finalValues);
    let mobileApllyFilters = document.getElementById('mobileApllyFilters');
    if (mobileApllyFilters) {
        mobileApllyFilters.innerHTML = `Ver ${finalValues.NumItems} Resultados`;
    }
    const featuresButtons = document.getElementsByClassName('js-feature-filter-btn');
    let featuresArrayButtons = Array.from(featuresButtons);
    if (finalValues.NumItems == 0) {
        featuresArrayButtons.forEach((button) => {
            button.setAttribute('disabled', 'true');
        });
    }
    else {
        featuresArrayButtons.forEach((button) => {
            button.removeAttribute('disabled');
        });
    }
    const res1 = await fetch(`/results-filters${filter}`);
    setTimeout(() => {
        if (document.getElementById("featuredProjectsVue")) {
            document.getElementById("featuredProjectsVue").classList.remove('d-none');
        }
    }, 500);
    initWhenReady(() => {
        document
            .querySelectorAll('.project-card__slider')
            .forEach((card) => {
            createStaticSlider(card, {
                perPage: 3,
                classes: { arrow: 'splide__arrow splide__arrow--blue' },
            }, { lazy: true });
        });
    });
    return await res1.json();
}
function loadSeoTags(finalSeoRes) {
    let currentTitle = document.getElementById('title') ? document.getElementById('title').textContent : '';
    let title = finalSeoRes.seo === undefined ? currentTitle : finalSeoRes.seo;
    let description = finalSeoRes.description;
    // Actualizar el título de la página
    if (document.getElementById('title')) {
        document.getElementById('title').innerHTML = title || '';
    }
    document.getElementById('first-results-section').innerHTML = '';
    if (document.getElementById('featuredProjectsResults')) {
        document.getElementById('featuredProjectsResults').innerHTML = '';
    }
    document.title = title || '';
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
        metaDescription.content = description;
    }
    // const descriptionFooter = document.getElementById('description-footer');
    // if (descriptionFooter) {
    //   descriptionFooter.innerHTML = description;
    // }
}
export function setdata(data) {
    var _a, _b;
    const number_total = data.NumItems;
    document.getElementById('number-total') ? document.getElementById('number-total').innerHTML = number_total.toString() : '';
    if (number_total <= 12) {
        (_a = document.getElementById('more-results')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
    }
    else {
        (_b = document.getElementById('more-results')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
    }
    // it is used to define the featured projects tab
    loadWithoutResults(number_total);
    // load info data
    loadInfoData(data, fields);
    // Load highlighted results
    loadSliderHiglighted('featuredProjectsResults');
    // load order
    loadFilterOrder();
    // load area and price slider
    setSlider('area');
    setSlider('precio');
    bindRangeInputs('area');
    bindRangeInputs('precio');
    setRangeHint('area');
    setRangeHint('precio');
    // send the data to vue - false for builder
    renderFilters(false);
}
